'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.months;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/months.js
// module id = 718
// module chunks = 0